import { Divider, Stack, Text, useScreenSize } from "flicket-ui";
import { AnimatePresence, motion } from "framer-motion";
import { useContext } from "react";
import { OrderSummaryContext } from "~features/checkout/pre-auth/components/OrderSummary/OrderSummaryContext";
import { SinglePageCheckoutOrderSummaryPromoCodeInput } from "~features/checkout/pre-auth/components/OrderSummary/PromoCode/PromoCodeInput";
import { SinglePageCheckoutOrderSummaryPromoCodeSummary } from "~features/checkout/pre-auth/components/OrderSummary/PromoCode/PromoCodeSummary";
import { SinglePageCheckoutServiceFees } from "~features/checkout/pre-auth/components/OrderSummary/ServiceFees";

export const OrderSummaryContent = ({
  displayTotal,
}: {
  displayTotal: boolean;
}) => {
  const { isTabletPortraitDown } = useScreenSize();
  const {
    subtitle,
    title,
    renderLineItems,
    renderTotals,
    allowPromoCode,
    isPromoCodeApplied,
  } = useContext(OrderSummaryContext);

  return (
    <Stack direction="vertical">
      <Stack gap={2} direction={"vertical"} mt={2}>
        <Stack direction={"vertical"} gap={"1/2"}>
          <Text variant={isTabletPortraitDown ? "header.S" : "regular"}>
            {title}
          </Text>
          <Text variant="small">{subtitle}</Text>
        </Stack>
        {allowPromoCode && <SinglePageCheckoutOrderSummaryPromoCodeInput />}

        <Stack direction={"vertical"} gap={1}>
          {renderLineItems()}
          <SinglePageCheckoutServiceFees />
        </Stack>

        {isPromoCodeApplied && (
          <SinglePageCheckoutOrderSummaryPromoCodeSummary />
        )}

        {displayTotal && (
          <>
            <Divider />
            {renderTotals()}
          </>
        )}
      </Stack>
    </Stack>
  );
};

export function ExpressOrderSummaryContent({
  isExpanded,
  displayTotal,
}: {
  isExpanded: boolean;
  displayTotal?: boolean;
}) {
  const isVisible = isExpanded;

  return (
    <AnimatePresence initial={false}>
      {isVisible && (
        <motion.div
          initial={{ height: 0, opacity: 0, overflow: "hidden" }}
          animate={{
            height: "auto",
            opacity: 1,
            transitionEnd: {
              overflow: "visible",
            },
          }}
          exit={{
            height: 0,
            opacity: 0,
            overflow: "hidden",
            transition: {
              opacity: {
                // Give opacity much faster transition to avoid content overlap
                duration: 0.1,
              },
            },
          }}
          transition={{ duration: 0.3, opacity: { delay: 0.2, duration: 0.2 } }}
        >
          <OrderSummaryContent displayTotal={displayTotal} />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
